import { Lock, Unlock } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormBlockDeblockuser from '../Forms/FormBlockDeblockuser';

export default function BlockDeblockUser(props: { handleFunction: any, user: any }) {
    const [open, setOpen] = React.useState(false);
    const isActive = props.user.Statut == 1;

    return (
        <div>
            <IconButton onClick={() => setOpen(true)} color={isActive ? 'success' : "danger"} size={28} tooltip={isActive ? 'Bloquer' : "Débloquer"}>
                {isActive ? <Unlock size={16} /> : <Lock size={16} />}
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`${isActive ? 'Blocage' : "Déblocage"} de l'utilisateur`}
                hint={isActive
                    ? "Attention : le blocage empêchera cet utilisateur de se connecter."
                    : "Le déblocage permettra à cet utilisateur de se reconnecter."}
            >
                <FormBlockDeblockuser handleFunction={() => { setOpen(false); props.handleFunction() }} user={props.user} />
            </FormDrawer>
        </div>
    );
}
